import { useTranslation } from 'react-i18next';

import { ContactTabSectionHeading } from '~/scenes/PeopleModule/components/Tabs/ContactTab/components/ContactTabSectionHeading';
import { ContactTabSectionAccess } from '~/scenes/PeopleModule/components/Tabs/ContactTab/useContactTab';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { OtherContactEditMode } from './components/OtherContactEditMode';
import { OtherContactReadMode } from './components/OtherContactReadMode';
import { useOtherContract } from './useOtherContact';

export const OtherContact = (props: ContactTabSectionAccess) => {
  const { canEdit } = props;

  const { form, actions, empData, readMode, countriesList, isLoading } =
    useOtherContract();
  const { t } = useTranslation();

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <ContactTabSectionHeading
        heading={t('laOtherContact')}
        canEdit={canEdit}
        readMode={readMode}
        {...actions}
      />
      {readMode === true ? (
        <OtherContactReadMode data={empData} countryList={countriesList} />
      ) : (
        <OtherContactEditMode form={form} countryList={countriesList} />
      )}
    </>
  );
};
